// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_i7-2";
export var aiChatCartContainerExit = "_i7-4";
export var aiChatContainerLarge = "_i7-0";
export var aiChatContainerSmall = "_i7-1";
export var aiChatIcon = "_i7-6";
export var slideInFromRight = "_i7-3";
export var slideOutToRight = "_i7-5";